import Image from 'next/image'
import USPImage from '../../../public/assets/usp.webp'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import PermPhoneMsgOutlinedIcon from '@mui/icons-material/PermPhoneMsgOutlined'

function USPDesktop() {
  return (
    <div id="usp-desktop" className="mt-[60px] mb-[76px] w-full flex flex-wrap gap-[20px] px-[70px] items-center justify-center">
      <div id="image" className='w-[265px] flex flex-col space-y-[89px] border-xs border-solid border-greyDisabledBackground50 rounded-[24px] custom-gradient whitespace-nowrap h-[265px]'>
        <Image src={USPImage} width={265} height={265} alt="usp_lokal.jobs" className='rounded-[24px]'/>
      </div>
      <div id="salary" className='w-[265px] flex flex-col font-noto-sans  space-y-[89px] border-xs border-solid border-greyDisabledBackground50 pl-[24px] pt-[24px] pr-[74px] rounded-[24px] custom-gradient whitespace-nowrap h-[265px]'>
        <CurrencyRupeeIcon sx={{
            width:"56px",
            height:"56px"
        }} className='text-blueSecondary500'/>
        <span className='font-noto-sans  text-[32px] font-[600] leading-[36px] text-greyTitleBase900'>Best salary</span>
      </div>
      <div id="jobs" className='w-[265px] font-noto-sans  flex flex-col space-y-[89px] border-xs border-solid border-greyDisabledBackground50 pl-[24px] pt-[24px] pr-[74px] rounded-[24px] custom-gradient h-[265px]'>
        <VerifiedUserOutlinedIcon sx={{
            width:"56px",
            height:"56px"
        }} className='text-blueSecondary500'/>
        <div className='flex flex-col'>
        <span className='font-noto-sans  text-[32px] font-[600] leading-[36px] text-greyTitleBase900 text-left whitespace-nowrap'>Verified local</span>
        <span className='font-noto-sans  text-[32px] font-[600] leading-[36px] text-greyTitleBase900 text-left whitespace-nowrap'>jobs</span>

        </div>

      </div>
      <div id="hr" className='w-[265px] flex flex-col space-y-[89px] border-xs border-solid border-greyDisabledBackground50 pl-[24px] pt-[24px] pr-[74px] rounded-[24px] custom-gradient text-left h-[265px]'>
        <PermPhoneMsgOutlinedIcon sx={{
            width:"56px",
            height:"56px"
        }} className='text-blueSecondary500'/>

       <div className='flex flex-col'>
        <span className='font-noto-sans text-[32px] font-[600] leading-[36px] text-greyTitleBase900 text-left whitespace-nowrap'>Talk directly</span>
        <span className='font-noto-sans text-[32px] font-[600] leading-[36px] text-greyTitleBase900 text-left whitespace-nowrap'>to HR</span>

        </div>
      </div>
    </div>
  )
}

export default USPDesktop
